<template>
	<div id="news">
		<div class="header">
				  <div class="logo-box">
					  <img class="logo" src="https://cdn.huimiaokeji.com/hjweb/logo.png" @click="navTo('/')"/>
				  </div>
				  <div class="top-menu">
					官方资讯
				  </div>
				  <div class="login-box" @click="goUrl('https://admin.huimiaokeji.com')">
					  <div class="login-btn">
						  登录
					  </div>
				  </div>
		</div>
		<div class="content-panel">
			<div class="link-box">
				<el-link href="/#/news" type="primary">官方资讯</el-link>
				<div style="font-size: 16px;margin-left: 5px;">/ 详情</div>
			</div>
			<h1 class="title">{{form.title}}</h1>
			<div v-html="form.content" style="margin-top: 50px;"></div>
		</div>
			<footer-menu></footer-menu>
	</div>
</template>

<script>
	import {getArticleDetail} from '../api/index.js';
	import FooterMenu from '../components/footer-menu.vue';
	export default {
		name:'NewsDetail',
		components: {
			FooterMenu
		},
		data() {
			return {
				form:{}
			}
		},
		props: ['articleId'],
		created() {
		  document.title = '灰鲸网络-资讯详情';
		  this.queryArticleDetail();
		},
		methods: {
			goUrl(url){
				window.open(url);
			},
			navTo(url) {
				this.$router.push({ path:url})
			},
			async queryArticleDetail() {
				let res = await getArticleDetail({articleId: this.articleId});
				if (res.code == 200) {
					this.form = res.data;
					if (this.form.content) {
						this.form.content = this.form.content.replace(/\<img/gi, '<img style="max-width:100%;height:auto" ') 
					}
				}
			},
		}
	}
</script>

<style lang="less">
	#news {
		background-color: #F3F7FF;
		.header {
			  width: 100%;
			  z-index: 999999;
			  position: fixed;
			  left: 0;
			  top:0 ;
			  display: flex;
			   height: 80px;
			   background-color: #FFFFFF;
			  .logo-box {
				  flex:1;
				  display: flex;
				  align-items: center;
				  .logo {
					margin-left: 40px;
					width: 205px;	
					height: 30px;
					cursor: pointer;
				  }
			  }
			  .top-menu{
				  flex:1;
					  font-size: 20px;
					  font-family: PingFangSC, PingFang SC;
					  font-weight: 400;
					  color: #333333;
					  line-height: 80px;
					  justify-content: space-between;
					  // padding-left: 200px;
					  // padding-right: 200px;
					  text-align: center;
			  }
			  .login-box {
				  flex:1;
				  cursor: pointer;
				  .login-btn {
					  width: 120px;
					  height: 80px;
					  background: #0B00B5;
					  font-family: PingFangSC, PingFang SC;
					  font-weight: bold;
					  font-size: 14px;
					  color: #FFFFFF;
					  line-height: 80px;
					  text-align: center;
					  font-style: normal;
					  float: right;
				  }
			  }
			  margin-bottom: 50px;
		  }
		  .content-panel{
			  padding-top:100px;
			  min-height: 180px;
			  width: 80%;
			  margin-left: 10%;
			  .title {
				  text-align: center;
			  }
			  margin-bottom: 50px;
			  .link-box {
				  display: flex;
			  }
		  }
	}
</style>


// WEBPACK FOOTER //
// src/pages/NewsDetail.vue